import { GlobalStore } from "../../../../../store/global/GlobalStore";
import { ProfileActionsContentNoConnection } from "./ProfileActionsContentNoConnection";
import { ProfileActionsContentWithConnection } from "./ProfileActionsContentWithConnection/ProfileActionsContentWithConnection";

interface ProfileActionsContentProps {
  closeDisplay: () => void;
}

export const ProfileActionsContent = ({ closeDisplay }: ProfileActionsContentProps) => {
  const address = GlobalStore.useState(s => s.address);

  if (address === "") {
    return <ProfileActionsContentNoConnection closeDisplay={closeDisplay} />;
  }

  return <ProfileActionsContentWithConnection closeDisplay={closeDisplay} />;
};
